<template>
  <!--课程购买-->
  <div>
    <headers></headers>
    <div class="padding88">
      <div class="divider">
        <div class="auto">
          <router-link to="/">首页</router-link> <span>></span>在线直播列表
        </div>
      </div>
    </div>
    <div v-if="lives.length !== undefined && lives.length > 0" class="padding250">
      <lives v-bind:lives="lives" v-bind:isVip="isVip"></lives>
      <div class="pageout"><Page :total="total" :current="pageNumber" :page-size="size" @on-change="changePage"/></div>
    </div>
    <div v-else>
      <nodata tip="暂时还没有直播哦~"></nodata>
    </div>
    <Spin fix v-show="isSpinShow" >
      <div class="loader">
        <Icon type="ios-loading" size=26 class="demo-spin-icon-load"></Icon>
        <div class="font14">加载中...</div>
      </div>
    </Spin>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  /* 旋转效果 */
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50% { transform: rotate(180deg);}
    to { transform: rotate(360deg);}
  }
  /* 假如内容过长，一屏放不下，滚动条下拉覆盖不全 */
  .ivu-spin-fix {
    position: fixed;
  }

  .divider{
    height: 60px;
    background-color: #2F261E;
    font-size: 14px;
    line-height: 60px;
    text-align: left;
    color: #fff;
    span{
      margin: 0 10px;
    }
    a{
      color: #fff;
      &:hover{
        color: #9C7649;
        font-weight: 700;
      }
    }
  }
</style>
<script type="text/ecmascript-6">
  import lives from '../template/live'
  import headers from '../template/header'
  import footers from '../template/footer'
  import nodata from '../template/null'
  import {centreInfoWeb, liveListWeb} from '../../http'
  import {getStore} from "../../storage";
  export default {
    name: 'list',
    props: {},
    data() {
      return {
        nowIndex:0,
        lives:'',         //直播列表
        total:0,
        size:16,
        pageNumber:1,
        isVip:0,          //用户是否是vip
        isSpinShow:false,
      };
    },
    methods: {
      //获取直播列表
      getLives(){
        liveListWeb({pageNumber: this.pageNumber,pageSize:this.size}).then(res => {
          this.isSpinShow = false;
          if (res.code === 200) {
            this.isVip = res.data.isVip;
            this.lives = res.data.list.rows;
            this.total = res.data.list.total;
          } else {
            this.$Notice.warning({
              title: '系统错误',
              desc: '请刷新页面',
              duration: 3,
            });
          }
        }).catch();
      },
      //页码切换
      changePage(pageNumber){
        this.pageNumber = pageNumber;
        if(this.isSpinShow === false) {
          this.isSpinShow = true;
          if (getStore('token') !== null && getStore('token') !== undefined && getStore('token') !== '') {
            //获取用户信息
            centreInfoWeb().then(res => {
              if (res.code === 200) {
                this.getLives();
              } else {
                this.getLives();
              }
            }).catch()
          } else {
            this.getLives();
          }
        }
      }
    },
    created() {
      if(this.isSpinShow === false) {
        this.isSpinShow = true;
        if (getStore('token') !== null && getStore('token') !== undefined && getStore('token') !== '') {
          //获取用户信息
          centreInfoWeb().then(res => {
            if (res.code === 200) {
              this.getLives();
            } else {
              this.getLives();
            }
          }).catch()
        } else {
          this.getLives();
        }
      }
    },
    components: {
      headers,
      footers,
      lives,
      nodata
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/buy/zhibolist.vue